// apps/web/src/components/ui/toast-duracao.ts — Fase 17.8, Plano 22 (D-19; UI-SPEC U-30).
// Duração de um toast: explícita (válida) > erro 10 s (inalterado) > com ação ("Desfazer") 8 s > padrão 5 s.
export const DURACAO_PADRAO_MS = 5000;
export const DURACAO_COM_ACAO_MS = 8000;
export const DURACAO_ERRO_MS = 10000;

export function duracaoDoToast(opcoes: { readonly duration?: number; readonly action?: unknown; readonly variant?: string }): number {
  const { duration } = opcoes;
  if (duration !== undefined && Number.isFinite(duration) && duration > 0) return duration;
  if (opcoes.variant === 'error') return DURACAO_ERRO_MS;
  if (opcoes.action) return DURACAO_COM_ACAO_MS;
  return DURACAO_PADRAO_MS;
}
